/**
 * Значения синхронизированы с enum'ами Prisma (backend/prisma/schema.prisma).
 * Объект + union вместо `enum` — так значения доступны в рантайме на всех трёх
 * приложениях и не ломают `isolatedModules`.
 */
export const Gender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
};
/** Кого ищет пользователь. `ANY` доступен только для темы «Общение». */
export const GenderPreference = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    ANY: 'ANY',
};
export const Topic = {
    FLIRT: 'FLIRT',
    CHAT: 'CHAT',
};
export const GENDERS = [Gender.MALE, Gender.FEMALE];
export const TOPICS = [Topic.FLIRT, Topic.CHAT];
/** Как пользователь вошёл. Гость доступен только в веб-версии. */
export const AuthProvider = {
    TELEGRAM: 'TELEGRAM',
    GUEST: 'GUEST',
};
export const UserStatus = {
    IDLE: 'IDLE',
    SEARCHING: 'SEARCHING',
    IN_CHAT: 'IN_CHAT',
};
export const ChatStatus = {
    ACTIVE: 'ACTIVE',
    CLOSED: 'CLOSED',
};
/**
 * Случайный диалог живёт до выхода собеседника, дружеский остаётся у обоих.
 * Дружба не заводит новый чат, а меняет вид этому — так у собеседника
 * сохраняется прозвище: оно выводится из участия в чате.
 */
export const ChatKind = {
    RANDOM: 'RANDOM',
    FRIEND: 'FRIEND',
};
export const FriendRequestStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    /** Отправитель передумал или диалог завершился раньше ответа. */
    CANCELLED: 'CANCELLED',
};
/** Поверхность приложения: сайт и мини-приложение настраиваются раздельно. */
export const AppSurface = {
    WEB: 'WEB',
    WEBAPP: 'WEBAPP',
};
export const ChatCloseReason = {
    NEXT: 'NEXT',
    LEAVE: 'LEAVE',
    DISCONNECT: 'DISCONNECT',
    REPORT: 'REPORT',
    BAN: 'BAN',
    SYSTEM: 'SYSTEM',
};
export const MessageType = {
    TEXT: 'TEXT',
    PHOTO: 'PHOTO',
    VOICE: 'VOICE',
    SYSTEM: 'SYSTEM',
};
export const MessageStatus = {
    SENDING: 'SENDING',
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    READ: 'READ',
    FAILED: 'FAILED',
};
/** Что за файл: снимок или голосовое. Конвейер хранения у них общий. */
export const MediaKind = {
    PHOTO: 'PHOTO',
    VOICE: 'VOICE',
};
export const MediaScanStatus = {
    PENDING: 'PENDING',
    CLEAN: 'CLEAN',
    INFECTED: 'INFECTED',
    ERROR: 'ERROR',
};
export const ReportReason = {
    SPAM: 'SPAM',
    INSULT: 'INSULT',
    PORN: 'PORN',
    SCAM: 'SCAM',
    UNDERAGE: 'UNDERAGE',
    OTHER: 'OTHER',
};
export const REPORT_REASONS = [
    ReportReason.SPAM,
    ReportReason.INSULT,
    ReportReason.PORN,
    ReportReason.SCAM,
    ReportReason.UNDERAGE,
    ReportReason.OTHER,
];
export const ReportStatus = {
    PENDING: 'PENDING',
    REVIEWING: 'REVIEWING',
    RESOLVED: 'RESOLVED',
    REJECTED: 'REJECTED',
};
export const ModerationAction = {
    BAN: 'BAN',
    AUTO_BAN: 'AUTO_BAN',
    UNBAN: 'UNBAN',
    WARN: 'WARN',
    IGNORE: 'IGNORE',
};
/** Путь обращения о неполадке: от «сломалось» до «починили». */
export const IssueStatus = {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    RESOLVED: 'RESOLVED',
    CLOSED: 'CLOSED',
};
export const ISSUE_STATUSES = [
    IssueStatus.NEW,
    IssueStatus.IN_PROGRESS,
    IssueStatus.RESOLVED,
    IssueStatus.CLOSED,
];
export const AdminRole = {
    ADMIN: 'ADMIN',
    MODERATOR: 'MODERATOR',
};
export const QueueLeaveReason = {
    MATCHED: 'MATCHED',
    CANCELLED: 'CANCELLED',
    TIMEOUT: 'TIMEOUT',
    DISCONNECTED: 'DISCONNECTED',
};
//# sourceMappingURL=enums.js.map